<div class="body-reset">
  <div class="error">
    <app-error-alert [message]="errorMessage" *ngIf="showAlertError"></app-error-alert>
    <app-success-alert *ngIf="showAlerSuccess" [message1]="message1ForSuccesAlert"
      [message2]="message2ForSuccesAlert"></app-success-alert>
  </div>
  <div class="iris-logo-wrapper">
  <img src="../../../assets/logo-iris.png" alt="Logo IRIS" class="iris-logo">
  </div>
  <button class="logout-button" (click)="cerrarSesion()">
  Cerrar Sesión
</button>
  <div class="form-container">
    <div class="form-header">
      <h1 class="form-title">
        <svg class="form-icon" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12,1A11,11 0 0,0 1,12A11,11 0 0,0 12,23A11,11 0 0,0 23,12A11,11 0 0,0 12,1M12,3A9,9 0 0,1 21,12A9,9 0 0,1 12,21A9,9 0 0,1 3,12A9,9 0 0,1 12,3M12,6A3,3 0 0,0 9,9V10A1,1 0 0,0 8,11V16A1,1 0 0,0 9,17H15A1,1 0 0,0 16,16V11A1,1 0 0,0 15,10V9A3,3 0 0,0 12,6M12,7A2,2 0 0,1 14,9V10H10V9A2,2 0 0,1 12,7Z"/>
        </svg>
        Cambiar Contraseña
      </h1>
      <p class="form-subtitle">Crea una nueva contraseña segura para tu cuenta</p>
      <div *ngIf="respuesta" class="form-error-message">
        <i class="form-error-icon">⚠</i>
        <span class="form-error-text">{{respuesta}}</span>
    </div>
    </div>
    

    <form class="password-form" #form="ngForm" (ngSubmit)="onSubmit(form)">
      <div class="form-group">
        <label class="form-label" for="text">Usuario de RED</label>
        <input 
          type="text" 
          name="email" 
          class="form-input" 
          readonly
          [(ngModel)]="usuario"
          [attr.disabled]="true"
        >
      </div>

      <div class="form-group">
        <label class="form-label form-label--required" for="password">Nueva Contraseña</label>
        <div style="position: relative;">
          <input 
            type="password"  
            name="password" 
            class="form-input" 
            [ngClass]="{'form-input--error': passwordModel.invalid && passwordModel.touched}"
            placeholder="Ingresa tu nueva contraseña"
            required
            [(ngModel)]="password"
            #passwordModel="ngModel"
            >
          </div>
          <div *ngIf="passwordModel.invalid && passwordModel.touched" class="form-error-message">
            <i class="form-error-icon">⚠</i>
            <span class="form-error-text">Este campo es requerido!</span>
          </div>
      </div>
      <div class="form-group">
        <label class="form-label form-label--required" for="confirmPassword">Confirmar Contraseña</label>
        <div style="position: relative;">
          <input 
            type="password" 
            name="confirm_password" 
            class="form-input" 
            [ngClass]="{'form-input--error': confirm_passwordModel.invalid && confirm_passwordModel.touched}"
            placeholder="Confirma tu nueva contraseña"
            required
            [(ngModel)]="confirm_password"
            #confirm_passwordModel="ngModel"
          >
        </div>
        <div *ngIf="confirm_passwordModel.invalid && confirm_passwordModel.touched" class="form-error-message">
            <i class="form-error-icon">⚠</i>
            <span class="form-error-text">Este campo es requerido!</span>
          </div>
      </div>

      <button type="submit" class="submit-button" id="submit-btn">
        <div class="loading-spinner"></div>
        Cambiar Contraseña
      </button>
    </form>
  </div>
  <app-confirmation-modal  class="custom-modal-reset" [isVisible]="isModalVisible" [confirmationText]="'¿Estás seguro que deseas cambiar tu contraseña? Esta acción no se puede deshacer.'" [confirmButtonText]="'Confirmar'"
    (confirmed)="onConfirm(form)" (canceled)="onCancel()"></app-confirmation-modal>
    
</div>
